import React from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { dateFormatOptions } from 'config/dateFormatterConfig'
import EditIcon from 'components/icons/EditIcon'
import DeleteIcon from 'components/icons/DeleteIcon'
import { TraderResponse } from '../models/types'

interface TraderTableRowProps {
  trader: TraderResponse
  onEdit: () => void
  onDelete: () => void
}

function addressOf(trader: TraderResponse) {
  const { address } = trader
  const street = address?.street
  const addressLine = address?.addressLine

  return [
    [street || addressLine, address?.streetNumber].filter(Boolean).join(' '),
    street ? addressLine : null,
    address?.postcode,
    address?.city,
  ].filter(Boolean).join(', ')
}

function contactPersonOf(trader: TraderResponse) {
  return [
    trader.contactPerson?.name,
    trader.contactPerson?.email,
    trader.contactPerson?.telephone,
  ].filter(Boolean).join(', ')
}

function TraderTableRow(props: Readonly<TraderTableRowProps>) {
  const { trader, onEdit, onDelete } = props
  const { t } = useTranslation()

  const lastUsedAt = trader.lastUsedAt
    ? new Intl.DateTimeFormat('et', dateFormatOptions).format(new Date(trader.lastUsedAt))
    : ''

  return (
    <tr>
      <td>
        <button
          type="button"
          className="btn btn-link no-underline pointer d-flex align-items-center border-0 w-100 h-100 p-0 lh-1"
          onClick={onEdit}
        >
          <span className="text-start">{trader.name}</span>
        </button>
      </td>
      <td className="pointer" role="presentation" onClick={onEdit}>{trader.identificationNumber}</td>
      <td className="pointer" role="presentation" onClick={onEdit}>{addressOf(trader)}</td>
      <td className="pointer" role="presentation" onClick={onEdit}>{contactPersonOf(trader)}</td>
      <td className="pointer" role="presentation" onClick={onEdit}>{lastUsedAt}</td>
      <td className="text-end">
        <div className="d-flex align-items-center justify-content-end gap-2">
          <Button
            type="button"
            variant="link"
            className="btn-icon"
            title={t('common.edit')}
            aria-label={t('common.edit')}
            onClick={onEdit}
          >
            <EditIcon />
          </Button>
          <Button
            type="button"
            variant="link"
            className="btn-trash"
            title={t('buttons.delete')}
            aria-label={t('buttons.delete')}
            onClick={onDelete}
          >
            <DeleteIcon />
          </Button>
        </div>
      </td>
    </tr>
  )
}

export default TraderTableRow
